import * as types from 'constants/actionTypes';

const queryChanged = ({ query }) => ({
    type: types.GLOSSARY_QUERY_CHANGED,
    payload: { query },
});

module.exports = queryChanged;
